
export const getAllUsers = (api, tokenType) => {
  return api.get("/user", { tokenType });
};
